import { styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from '@4c/layout';

import Card from './Card';
import LinkButton from './LinkButton';

import utilStyles from '../styles/utils.module.scss';

const EditButton = styled(LinkButton, null, "EditButton", require("./AddressCard-EditButton.module.scss"), "edit-button", "editButton");

const propTypes = {};

function AddressCard({
  onEdit,
  email,
  address: { attention, name, line1, line2, city, state, postalCode, phone },
}) {
  return (
    <Card>
      <Card.Body display="flex" direction="row" justify="space-between">
        <Layout className={utilStyles.flexWrapPad6}>
          <address>
            <div>{name}</div>
            {attention && (
              <FormattedMessage
                tagName="div"
                id="addressCard.attention"
                defaultMessage="attn: {attention}"
                values={{ attention }}
              />
            )}
            <div>
              {line1} {line2}
            </div>
            <div>
              {city}, {state} {postalCode}
            </div>
          </address>
          <div>
            <div>{email}</div>
            <div>{phone}</div>
          </div>
        </Layout>
        <Layout.Block>
          <EditButton onClick={onEdit}>
            <FormattedMessage
              defaultMessage="Edit"
              id="addressCard.editAddress"
            />
          </EditButton>
        </Layout.Block>
      </Card.Body>
    </Card>
  );
}

AddressCard.propTypes = propTypes;

export default AddressCard;
